import { useEffect, useState } from "react";
import { Users, Plus, Search, Save, Trash2, X, Edit3 } from "lucide-react";
import { toast } from "sonner";
import api, { readError } from "../api";

const emptyCustomer = () => ({
  name: "", company_name: "", tax_number: "", tax_office: "",
  email: "", phone: "", address: "", contact_person: "", notes: "",
});

export default function CustomerList({ customers, loadCustomers }) {
  const [filter, setFilter] = useState("");
  const [editing, setEditing] = useState(null);

  const save = async () => {
    if (!editing.name.trim()) return toast.error("Ad zorunlu");
    try {
      if (editing.id) await api.put(`/customers/${editing.id}`, editing);
      else await api.post("/customers", editing);
      toast.success("Cari kaydedildi");
      setEditing(null);
      loadCustomers();
    } catch (err) { toast.error(readError(err)); }
  };
  const remove = async (id) => {
    if (!window.confirm("Cari silinsin mi?")) return;
    try { await api.delete(`/customers/${id}`); toast.success("Silindi"); loadCustomers(); }
    catch (err) { toast.error(readError(err)); }
  };

  const filtered = customers.filter(c => {
    if (!filter) return true;
    const q = filter.toLowerCase();
    return (c.name||"").toLowerCase().includes(q) ||
           (c.company_name||"").toLowerCase().includes(q) ||
           (c.tax_number||"").includes(q) ||
           (c.phone||"").includes(q);
  });

  return (
    <section className="customers-view">
      <div className="catalog-intro">
        <div className="settings-icon"><Users size={22} /></div>
        <div>
          <p className="eyebrow blue">CARİ LİSTESİ</p>
          <h2>Müşteriler</h2>
          <p>Cariler kayıtlıysa teklif oluştururken "Cari listesinden seç" ile hızlıca ekleyebilirsiniz.</p>
        </div>
      </div>
      <div className="catalog-actions">
        <div className="search-box catalog-search">
          <Search size={16} />
          <input data-testid="customer-search-input" placeholder="Ad, firma, vergi no, telefon ara"
            value={filter} onChange={e => setFilter(e.target.value)} />
        </div>
        <button data-testid="new-customer-button" className="primary-button"
          onClick={() => setEditing(emptyCustomer())}>
          <Plus size={16} /> Yeni cari
        </button>
      </div>
      {filtered.length === 0 ? (
        <div className="empty-state">
          <Users size={30} />
          <h2>Cari bulunamadı</h2>
          <p>Yeni cari ekleyin, teklif oluştururken hızla seçebilesiniz.</p>
        </div>
      ) : (
        <div className="catalog-list">
          <div className="customer-row customer-head">
            <span>Ad / Firma</span><span>Yetkili</span><span>Telefon / E-posta</span><span>Vergi</span><span></span>
          </div>
          {filtered.map(c => (
            <div className="customer-row" key={c.id} data-testid={`customer-row-${c.id}`}>
              <div><b>{c.company_name || c.name}</b><small>{c.address}</small></div>
              <span>{c.contact_person || "-"}</span>
              <div><span>{c.phone || "-"}</span><small>{c.email || ""}</small></div>
              <div><span>{c.tax_number || "-"}</span><small>{c.tax_office || ""}</small></div>
              <div className="customer-actions">
                <button className="icon-button" title="Düzenle" onClick={() => setEditing(c)}
                  data-testid={`edit-customer-${c.id}`}><Edit3 size={14} /></button>
                <button className="icon-button" title="Sil" onClick={() => remove(c.id)}
                  data-testid={`delete-customer-${c.id}`}><Trash2 size={14} /></button>
              </div>
            </div>
          ))}
        </div>
      )}

      {editing && (
        <div className="modal-overlay" onClick={() => setEditing(null)}>
          <div className="modal-card lg" onClick={e => e.stopPropagation()} data-testid="customer-modal">
            <button className="modal-close" onClick={() => setEditing(null)}><X size={16} /></button>
            <h2>{editing.id ? "Cari düzenle" : "Yeni cari"}</h2>
            <div className="settings-grid">
              <label>Ad<input data-testid="customer-name-field" value={editing.name} onChange={e => setEditing({ ...editing, name: e.target.value })} /></label>
              <label>Firma adı<input data-testid="customer-company-field" value={editing.company_name} onChange={e => setEditing({ ...editing, company_name: e.target.value })} /></label>
              <label>Yetkili kişi<input data-testid="customer-contact-field" value={editing.contact_person} onChange={e => setEditing({ ...editing, contact_person: e.target.value })} /></label>
              <label>Telefon<input data-testid="customer-phone-field" value={editing.phone} onChange={e => setEditing({ ...editing, phone: e.target.value })} /></label>
              <label>E-posta<input data-testid="customer-email-field" value={editing.email} onChange={e => setEditing({ ...editing, email: e.target.value })} /></label>
              <label>Vergi dairesi<input data-testid="customer-tax-office-field" value={editing.tax_office} onChange={e => setEditing({ ...editing, tax_office: e.target.value })} /></label>
              <label>Vergi / TC no<input data-testid="customer-tax-number-field" value={editing.tax_number} onChange={e => setEditing({ ...editing, tax_number: e.target.value })} /></label>
              <label className="full-field">Adres<textarea data-testid="customer-address-field" value={editing.address} onChange={e => setEditing({ ...editing, address: e.target.value })} /></label>
              <label className="full-field">Not<textarea data-testid="customer-notes-field" value={editing.notes} onChange={e => setEditing({ ...editing, notes: e.target.value })} /></label>
            </div>
            <div className="settings-actions">
              <button className="outline-button" onClick={() => setEditing(null)}>Vazgeç</button>
              <button className="primary-button" onClick={save} data-testid="customer-save-button">
                <Save size={16} /> Kaydet
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
